import { MotionProps } from 'framer-motion';
import React from 'react';
import Balancer from 'react-wrap-balancer';

import { jakarta } from '@/lib/fonts';
import { cn } from '@/lib/utils';

export const Heading = ({
  className,
  as: Tag = 'h2',
  children,
  size = 'md',
  ...props
}: {
  className?: string;
  as?: any;
  children: any;
  size?: 'sm' | 'md' | 'xl' | '2xl';
  props?: React.HTMLAttributes<HTMLHeadingElement>;
} & MotionProps &
  React.HTMLAttributes<HTMLHeadingElement>) => {
  const sizeVariants = {
    sm: 'text-xl md:text-2xl md:leading-snug',
    md: 'text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.15]',
    xl: 'text-4xl md:text-6xl leading-[1.1]',
    '2xl': 'text-5xl md:text-7xl leading-[1.05]',
  };
  return (
    <Tag
      className={cn(
        jakarta.className,
        'max-w-5xl mx-auto text-center tracking-tight',
        'font-bold',
        'text-[#2e1452] dark:text-white',
        sizeVariants[size],
        className
      )}
      {...props}
    >
      <Balancer>{children}</Balancer>
    </Tag>
  );
};
